import { render } from "./VentasCreateCredito.vue?vue&type=template&id=00ffd463&scoped=true"
import script from "./VentasCreateCredito.vue?vue&type=script&lang=js"
export * from "./VentasCreateCredito.vue?vue&type=script&lang=js"

import "./VentasCreateCredito.vue?vue&type=style&index=0&id=00ffd463&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ffd463"]])

export default __exports__